// src/HR/Assign_Course/AssignCourse.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography, Button, useMediaQuery, useTheme } from '@mui/material';
import useAssignCourse from '../Assign_Course/hooks/useAssignCourse';
import { fetchAssignmentDetails, fetchAssignedExamDetails } from '../Assign_Course/utils/fetchUtils';
import {
    mergeAssignedData,
    handleAssign,
    resetform,
    confirmSaveCourse,
    handleClear,
} from '../Assign_Course/utils/handleUtils';
import Sidebar from '../../Temp/Sidebar/Sidebar';
import "../../AdminConfig/AdminConfig.css";
// Add these imports after the other dialog imports
import RescheduleDialog from './dialogs/RescheduleDialog';
import MaxAttemptsDialog from './dialogs/MaxAttemptsDialog';

import DifficultySelector from '../Assign_Course/components/DifficultySelector';
import ExamSelector from '../Assign_Course/components/ExamSelector';
import DateTimeInputs from '../Assign_Course/components/DateTimeInputs';
import ConfirmDialog from '../Assign_Course/dialogs/ConfirmDialog';
import SuccessDialog from '../Assign_Course/dialogs/SuccessDialog';
import ClearConfirmDialog from '../Assign_Course/dialogs/ClearConfirmDialog';
import ClearSuccessDialog from '../Assign_Course/dialogs/ClearSuccessDialog';

import IndividualEmployeesTable from '../Assign_Course/Individual_employees_table/IndividualEmployeesTable';
import DepartmentTable from '../Assign_Course/department_table/DepartmentTable';
import OneTimeUserTable from '../Assign_Course/one_time_user_table/OneTimeUserTable';
import Groups from '../Assign_Course/groups_table/Groups';

import './AssignCourse.css';
import '../../theme.css';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { useAuthorization } from '../Assign_Course/hooks/useAuthorization';
import '../../Final_Css/positiveflowbuttons.css';
import '../../css/Updatedstyles.css';
import { useOutletContext, Navigate } from "react-router-dom";

const AssignCourse = () => {
    const location = useLocation();
    const examData = location.state?.exam;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const { permissionLevel } = useAuthorization();
    const disableActions = permissionLevel !== 2;
    const [clearConfirmOpen, setClearConfirmOpen] = React.useState(false);
    const [clearSuccessOpen, setClearSuccessOpen] = React.useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [autoScheduling, setAutoScheduling] = useState(0);

    const {
        isedit,
        navigate,
        selectedDepartments,
        setSelectedDepartments,
        selectedEmployees,
        setSelectedEmployees,
        difficulty,
        setDifficulty,
        exams,
        setExams,
        scheduleDate,
        setScheduleDate,
        expiryDate,
        setExpiryDate,
        oneTimeUsers,
        setOneTimeUsers,
        confirmOpen,
        setConfirmOpen,
        confirmationType,
        setConfirmationType,
        successOpen,
        setSuccessOpen,
        difficulties,
        setDifficulties,
        difficultyId,
        setDifficultyId,
        error,
        setError,
        selectedExam,
        setSelectedExam,
        selectedExamId,
        setSelectedExamId,
        departments,
        setDepartments,
        assignedData,
        setAssignedData,
        assignments,
        setAssignments,
        selectedAssignmentId,
        setSelectedAssignmentId,
        individuals,
        setIndividuals,
        selectedExamDuration,
        setSelectedExamDuration,
        oneTimeEmployees,
        setOneTimeEmployees,
        workStart, setWorkStart,
        workEnd, setWorkEnd,
    } = useAssignCourse();

    const [rescheduleDialogOpen, setRescheduleDialogOpen] = useState(false);
    const [rescheduleDialogData, setRescheduleDialogData] = useState(null);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorDialogData, setErrorDialogData] = useState(null);

    const { permissionSet, permissionsLoading } = useOutletContext();

    const canAccessAssessment = permissionSet.has(1) || permissionSet.has(2);

    if (!canAccessAssessment) {
    }

    useEffect(() => {
        fetchAssignmentDetails(setAssignments, setError);
    }, []);

    //     useEffect(() => {
    //     const loadSchedulingConfig = async () => {
    //         const config = await fetchSchedulingConfig();
    //         setAutoScheduling(config);
    //     };

    //     loadSchedulingConfig();
    // }, []);

    const isEdit = !!examData;

    useEffect(() => {
        if (examData) {
            const fetchData = async () => {
                try {
                    await fetchAssignedExamDetails(examData.assignId, setAssignedData, setError);
                } catch (err) {
                    console.error("Error fetching assigned assessment details:", err);
                }
            };
            fetchData();

            setSelectedExamId(examData.examId);
            setDifficultyId(examData.difficultyId);
            setScheduleDate(format(new Date(examData.scheduleDateTime), "yyyy-MM-dd'T'HH:mm"));
            setExpiryDate(format(new Date(examData.expiryDateTime), "yyyy-MM-dd'T'HH:mm"));
            setSelectedExam(examData.title);
            setDifficulty(examData.difficulty);
            setSelectedAssignmentId(examData.assignmentTypeId);
        }
    }, [examData]);

    const minScheduleDate = format(new Date(), "yyyy-MM-dd'T'00:00");
    const minExpiryDate = scheduleDate || minScheduleDate;

    const handleAssignmentClick = (assignmentId) => {
        if (!selectedExamId) {
            setError("Please select an assessment first.");

            setTimeout(() => {
                setError("");
            }, 5000);

            return;
        }
        setSelectedAssignmentId(assignmentId);
    };


    const handleBackToTabs = () => {
        setSelectedAssignmentId(null);
    };

    const handleClearConfirmed = () => {
        handleClear(
            null,
            setSelectedDepartments,
            setSelectedEmployees,
            setDifficulty,
            setExams,
            setScheduleDate,
            setExpiryDate,
            setSelectedExam,
            setSelectedExamId,
            setOneTimeUsers,
            setDifficultyId,
            setAssignedData,
            setSelectedAssignmentId,
            setOneTimeEmployees
        );

        setClearConfirmOpen(false);
        setClearSuccessOpen(true);
    };

    // Add these handler functions after handleClearConfirmed
    const handleReschedule = () => {
        setRescheduleDialogOpen(false);
        // You can navigate to reschedule page or open a modal
        // navigate('/hr/reschedule-exam');
        console.log("Reschedule action triggered");
    };

    const handleViewAttempts = () => {
        setErrorDialogOpen(false);
        // Navigate to attempts page
        if (errorDialogData?.examId) {
            navigate(`/hr/exam-attempts/${errorDialogData.examId}`);
        }
    };

    const hasTableData = useMemo(() => {
        if (!selectedAssignmentId) return false;
        if ([1, 2, 4].includes(selectedAssignmentId)) {
            return assignedData.some(item => item.assignmentId === selectedAssignmentId);
        }
        if (selectedAssignmentId === 3) {
            return oneTimeEmployees.length > 0;
        }
        return false;
    }, [assignedData, selectedAssignmentId, oneTimeEmployees]);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(""), 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    if (permissionsLoading) return <div>Loading...</div>;



    if (!canAccessAssessment) {
        return <Navigate to="/error" replace />;
    }
    // Map assignment ID to type string
    const getAssignmentType = (id) => {
        if (id === 1) return "Individual";
        if (id === 2) return "Department";
        if (id === 3) return "OneTime";
        if (id === 4) return "Groups";
        return "";
    };

    const assignmentType = getAssignmentType(selectedAssignmentId);

    // Count selected employees for Individual assignment (id=1)
    const selectedEmployeesCount = selectedAssignmentId === 1
        ? assignedData.filter(item => item.assignmentId === 1 && item.isActive !== false).length
        : 0;

    // Count selected departments for Department assignment (id=2)
    const selectedDepartmentsCount = selectedAssignmentId === 2
        ? assignedData.filter(item => item.assignmentId === 2 && item.isActive !== false).length
        : 0;








    return (
        <div className="flex min-h-screen relative">
            {/* Mobile Menu Button */}
            {isMobile && (
                <button
                    className="fixed top-4 left-4 z-50 p-2 bg-white rounded-md shadow-md"
                    onClick={toggleSidebar}
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            )}

            {/* Sidebar - responsive behavior */}
            {/* <div className={`${isMobile ? (sidebarOpen ? 'fixed inset-0 z-40' : 'hidden') : 'w-[95px]'} flex-shrink-0`}>
                <Sidebar onClose={isMobile ? toggleSidebar : null} />
            </div> */}

            {/* Overlay for mobile sidebar */}
            {isMobile && sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-30"
                    onClick={toggleSidebar}
                />
            )}

            {/* Main Content Area */}
            <div className={`flex-1 ${isMobile ? 'pt-16 px-4' : 'pl-6 pr-6 pt-6'} overflow-x-hidden transition-all duration-300`}>
                <div className="bgImage">
                    <Box className="MainSectionTop" sx={{ width: "100%" }}>



                        {/* Header for mobile */}
                        {/* {isMobile && (
                            <div className="mobile-header">
                                <Typography variant="h6" className="page-heading">
                                    Assign Assessment
                                </Typography>
                            </div>
                        )} */}

                        {isMobile && (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2,
                                    pr: 1
                                }}
                            >
                                <Typography variant="h6" className="page-heading">
                                    Assign Assessment
                                </Typography>

                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: "11px",
                                            color: "#374151",
                                            whiteSpace: "nowrap"
                                        }}
                                    >
                                        Auto Scheduling
                                    </Typography>

                                    <label className="toggle-switch">
                                        <input
                                            type="checkbox"
                                            checked={autoScheduling === 1}
                                            onChange={(e) => {
                                                setAutoScheduling(e.target.checked ? 1 : 0);
                                            }}
                                        />
                                        <span className="slider"></span>
                                    </label>

                                    <Typography
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 600,
                                            color: autoScheduling === 1 ? "#16a34a" : "#dc2626"
                                        }}
                                    >
                                        {autoScheduling === 1 ? "ON" : "OFF"}
                                    </Typography>
                                </Box>
                            </Box>
                        )}

                        {/* Two separate cards container
                        <div className={`two-column-container ${isMobile ? 'mobile-column' : ''}`}>
 
                            {/* LEFT CARD */}
                        {/* <div className={`form-card form-card-left ${isMobile ? 'mobile-card' : ''}`}>
                                {!isMobile && (
                                    <Typography variant="h5" className="card-heading">
                                        Assign Assessment
                                    </Typography> */}

                        {/* Two separate cards container */}
                        <div className={`two-column-container ${isMobile ? 'mobile-column' : ''}`}>

                            {/* LEFT CARD */}
                            <div className={`form-card form-card-left ${isMobile ? 'mobile-card' : ''}`}>
                                {!isMobile && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            mb: 2
                                        }}
                                    >
                                        <Typography variant="h5" className="card-heading">
                                            Assign Assessment
                                        </Typography>

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1.5
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                    color: "#374151"
                                                }}
                                            >
                                                Assign Free slots
                                            </Typography>

                                            <label className="toggle-switch">
                                                <input
                                                    type="checkbox"
                                                    checked={autoScheduling === 1}
                                                    onChange={async (e) => {
                                                        const value = e.target.checked ? 1 : 0;

                                                        setAutoScheduling(value);

                                                        // await updateSchedulingConfig(value);
                                                    }}
                                                />
                                                <span className="slider"></span>
                                            </label>

                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: 600,
                                                    color: autoScheduling === 1 ? "#16a34a" : "#dc2626"
                                                }}
                                            >
                                                {autoScheduling === 1 ? "ON" : "OFF"}
                                            </Typography>
                                        </Box>
                                    </Box>
                                )}



                                {error && (
                                    <Box
                                        sx={{
                                            backgroundColor: '#ffebee',
                                            color: '#c62828',
                                            p: 1,
                                            textAlign: 'center',
                                            fontSize: isMobile ? '0.75rem' : '0.85rem',
                                        }}
                                    >
                                        {error}
                                    </Box>
                                )}

                                <div className={`assign-assessment-controls-row ${isMobile ? 'mobile-grid' : ''}`}>
                                    <div className="form-top-grid">
                                    <ExamSelector
                                        isEdit={isEdit}
                                        exams={exams}
                                        selectedExam={selectedExam}
                                        setSelectedExam={setSelectedExam}
                                        setSelectedExamId={setSelectedExamId}
                                        setSelectedExamDuration={setSelectedExamDuration}
                                        isMobile={isMobile}
                                        setError={setError}
                                    />
                                    </div>

                                    <DateTimeInputs
                                        isEdit={isEdit}
                                        scheduleDate={scheduleDate}
                                        setScheduleDate={setScheduleDate}
                                        expiryDate={expiryDate}
                                        setExpiryDate={setExpiryDate}
                                        minScheduleDate={minScheduleDate}
                                        minExpiryDate={minExpiryDate}
                                        workStart={workStart}
                                        setWorkStart={setWorkStart}
                                        workEnd={workEnd}
                                        setWorkEnd={setWorkEnd}
                                        isMobile={isMobile}
                                    />
                                </div>
                            </div>

                            {/* RIGHT CARD */}
                            <div className={`form-card form-card-right ${isMobile ? 'mobile-card' : ''}`}>
                                {selectedAssignmentId ? (
                                    <>
                                        {selectedAssignmentId === 1 && (
                                            <IndividualEmployeesTable
                                                isEdit={isEdit}
                                                setError={setError}
                                                individuals={assignedData.filter(item => item.assignmentId === 1)}
                                                sendTableDataToParent={(data) => mergeAssignedData(data, 1, setAssignedData)}
                                                examid={selectedExamId}
                                                isMobile={isMobile}
                                            />
                                        )}
                                        {selectedAssignmentId === 2 && (
                                            <DepartmentTable
                                                isEdit={isEdit}
                                                examid={selectedExamId}
                                                departments={departments}
                                                selectedDepartments={selectedDepartments}
                                                setError={setError}
                                                employees={assignedData.filter(item => item.assignmentId === 2)}
                                                onEmployeesChange={(employees) => mergeAssignedData(employees, 2, setAssignedData)}
                                                isMobile={isMobile}
                                            />
                                        )}
                                        {selectedAssignmentId === 3 && (
                                            <OneTimeUserTable
                                                isEdit={isEdit}
                                                oneTimeUsers={oneTimeEmployees}
                                                setOneTimeUsers={setOneTimeEmployees}
                                                departments={departments}
                                                setError={setError}
                                                mergeAssignedData={mergeAssignedData}
                                                isMobile={isMobile}
                                            />
                                        )}
                                        {selectedAssignmentId === 4 && (
                                            <Groups
                                                setError={setError}
                                                groups={assignedData.filter(item => item.assignmentId === 4)}
                                                sendTableDataToParent={(data) => mergeAssignedData(data, 4, setAssignedData)}
                                                examid={selectedExamId}
                                                isMobile={isMobile}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <div className={`assignment-preview ${isMobile ? 'mobile-preview' : ''}`}>
                                        <Typography variant={isMobile ? "subtitle1" : "h6"} sx={{ color: '#4b5563' }}>
                                            Select Assignment Type
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#9ca3af', mb: 1, fontSize: isMobile ? '0.875rem' : 'inherit' }}>
                                            Choose who will take this assessment
                                        </Typography>

                                        <div className={`preview-icons ${isMobile ? 'mobile-icons' : ''}`}>
                                            <div className="preview-icon" onClick={() => handleAssignmentClick(1)}>
                                                <svg fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                                <div>Individual</div>
                                            </div>

                                            <div className="preview-icon" onClick={() => handleAssignmentClick(2)}>
                                                <svg fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
                                                </svg>
                                                <div>Department</div>
                                            </div>

                                            {/* <div className="preview-icon" onClick={() => handleAssignmentClick(4)}>
                                                <svg fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
                                                </svg>
                                                <div>Groups</div>
                                            </div> */}
                                            <div className="preview-icon" onClick={() => handleAssignmentClick(4)}>
                                                <svg fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 2.03 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                                                </svg>
                                                <div>Groups</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ACTION BUTTONS */}
                        <div
                            className={`action-buttons ${isMobile ? 'mobile-actions' : ''}`}
                            style={{ display: 'flex', alignItems: 'center', width: '100%' }}
                        >


                            {/* RIGHT SIDE BUTTONS */}
                            <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                                {/* LEFT BUTTON */}
                                {selectedAssignmentId && (
                                    <button
                                        onClick={handleBackToTabs}
                                        disabled={hasTableData || isEdit}
                                        className={`change-assignment-type-btn ${hasTableData ? 'disabled-data' : ''} ${isMobile ? 'mobile-btn' : ''}`}
                                    >
                                        {hasTableData ? 'Change Type (Data Added)' : 'Change Assignment Type'}
                                    </button>
                                )}
                                <button
                                    className={`btn ${isMobile ? 'mobile-action-btn' : ''}`}
                                    disabled={disableActions}
                                    style={{
                                        opacity: disableActions ? 0.5 : 1,
                                        cursor: disableActions ? "not-allowed" : "pointer",
                                        flex: isMobile ? '1' : 'inherit'
                                    }}
                                    onClick={() => handleAssign(
                                        difficultyId,
                                        scheduleDate,
                                        expiryDate,
                                        selectedExamId,
                                        assignedData,
                                        oneTimeEmployees,
                                        selectedExamDuration,
                                        setError,
                                        setConfirmationType,
                                        setConfirmOpen,
                                        isEdit,
                                        assignmentType,
                                        selectedEmployeesCount,
                                        selectedDepartmentsCount,
                                        workStart,
                                        workEnd,
                                        autoScheduling,
                                        navigate,
                                        setRescheduleDialogOpen,
                                        setRescheduleDialogData,
                                        setErrorDialogOpen,
                                        setErrorDialogData
                                    )}
                                >
                                    {isMobile ? 'Assign' : 'Assign Assessment'}
                                </button>

                                <button
                                    className={`btn-negative ${isMobile ? 'mobile-action-btn' : ''}`}
                                    disabled={disableActions}
                                    style={{
                                        opacity: disableActions ? 0.5 : 1,
                                        cursor: disableActions ? "not-allowed" : "pointer",
                                        flex: isMobile ? '1' : 'inherit'
                                    }}
                                    onClick={() => setClearConfirmOpen(true)}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </Box>
                </div>

                {/* <ConfirmDialog
                    confirmOpen={confirmOpen}
                    setConfirmOpen={setConfirmOpen}
                    error={error}
                    confirmSaveCourse={() => confirmSaveCourse(
                        isEdit,
                        assignedData,
                        oneTimeEmployees,
                        difficultyId,
                        scheduleDate,
                        expiryDate,
                        selectedExamId,
                        selectedExamDuration,
                        setError,
                        setConfirmOpen,
                        setSuccessOpen,
                        selectedAssignmentId,
                        workStart,
                        workEnd,
                        autoScheduling

                    )}
                    isMobile={isMobile}
                /> */}
                <ConfirmDialog
                    confirmOpen={confirmOpen}
                    setConfirmOpen={setConfirmOpen}
                    error={error}
                    confirmSaveCourse={() => {
                        // This function will be called when the user clicks Confirm
                        confirmSaveCourse(
                            isEdit,
                            assignedData,
                            oneTimeEmployees,
                            difficultyId,
                            scheduleDate,
                            expiryDate,
                            selectedExamId,
                            selectedExamDuration,
                            setError,
                            setConfirmOpen,
                            setSuccessOpen,
                            selectedAssignmentId,
                            workStart,
                            workEnd,
                            autoScheduling,
                            navigate,
                            setRescheduleDialogOpen,
                            setRescheduleDialogData,
                            setErrorDialogOpen,
                            setErrorDialogData
                        );
                    }}
                    isMobile={isMobile}
                />
                <ClearConfirmDialog
                    open={clearConfirmOpen}
                    setOpen={setClearConfirmOpen}
                    onConfirm={handleClearConfirmed}
                    isMobile={isMobile}
                />

                <ClearSuccessDialog
                    open={clearSuccessOpen}
                    setOpen={setClearSuccessOpen}
                    isMobile={isMobile}
                />

                <SuccessDialog
                    successOpen={successOpen}
                    setSuccessOpen={setSuccessOpen}
                    resetform={() => resetform(
                        null,
                        setSelectedDepartments,
                        setSelectedEmployees,
                        setDifficulty,
                        setExams,
                        setScheduleDate,
                        setExpiryDate,
                        setOneTimeUsers,
                        setDifficultyId,
                        setSelectedExam,
                        setSelectedExamId,
                        setAssignedData,
                        setSelectedAssignmentId,
                        setIndividuals,
                        setDepartments,
                        navigate
                    )}
                    isMobile={isMobile}
                />

                {/* Add these after SuccessDialog */}
                <RescheduleDialog
                    open={rescheduleDialogOpen}
                    onClose={() => setRescheduleDialogOpen(false)}
                    data={rescheduleDialogData}
                    onReschedule={handleReschedule}
                    isMobile={isMobile}
                />

                <MaxAttemptsDialog
                    open={errorDialogOpen}
                    onClose={() => setErrorDialogOpen(false)}
                    data={errorDialogData}
                    onViewAttempts={handleViewAttempts}
                    isMobile={isMobile}
                />
            </div>
        </div>
    );
};

export default AssignCourse;
